import { Box, BoxProps } from '@material-ui/core'
import React from 'react'

const Flex: React.FC<BoxProps> = (props) => (
	<Box flex={1} flexDirection='column' {...props} display='flex' />
)

export default Flex
